import * as Yup from 'yup';

export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/;

export const password = Yup.string()
  .min(8, 'Must be at least 8 characters')
  .max(50)
  .required('Password is required')
  .matches(passwordRegex, 'Must contain an uppercase, lowercase, number & special character');

export const confirmPassword = Yup.string()
  .required('Confirm password is required')
  .oneOf(
    // @ts-expect-error null not assignable
    [Yup.ref('password'), null],
    'Passwords must match',
  );
